import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapContextMenu = React.lazy(function () {
    return import('../../bootstrap-components/components/BTContextMenu');
});
var bootStrapContextMenu = function (props) {
    var newProps = __assign({}, props);
    return (React.createElement(BootStrapContextMenu, __assign({}, newProps)));
};
var ContextMenu = function (props) {
    var componentToDisplay = bootStrapContextMenu(props);
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapContextMenu(props);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) },
            " ",
            componentToDisplay,
            " ")));
};
ContextMenu.defaultProps = {
    styleName: 'primary',
    ioTheme: themes[0],
    ioMode: 'light'
};
export default React.memo(ContextMenu);
//# sourceMappingURL=ContextMenu.js.map